import { router } from 'expo-router';
import { useSetAtom } from 'jotai/index';
import React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonVariant,
    KeyboardCompatibleBottomSheet,
    YStack,
} from 'smoothie';

import {
    selectedManualAccountAtom,
    selectedManualInstitutionAtom,
} from '../state/OnboardingAtoms';

const FailedConnectionSheet = ({
    onDismiss,
    institutionName,
    connectInstitution,
}: {
    onDismiss: () => void;
    institutionName: string;
    connectInstitution: () => void;
}) => {
    const setSelectedManualAccount = useSetAtom(selectedManualAccountAtom);
    const setSelectedManualInstitution = useSetAtom(
        selectedManualInstitutionAtom,
    );

    return (
        <KeyboardCompatibleBottomSheet
            title="Failed to connect"
            showCloseButton
            onDismiss={onDismiss}
        >
            <YStack gap={24}>
                <BodyMediumRegular textAlign="center" color="$gray1000">
                    {`We were unable to connect to ${institutionName}. You can try again, or add your account details manually for now.`}
                </BodyMediumRegular>
                <YStack gap={16}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        text="Try connecting again"
                        onPress={() => {
                            onDismiss();
                            connectInstitution();
                        }}
                    />
                    <Button
                        variant={ButtonVariant.TERTIARY}
                        text="Manually add accounts"
                        onPress={() => {
                            setSelectedManualAccount(null);
                            setSelectedManualInstitution(institutionName);
                            onDismiss();
                            router.navigate('/holistic/edit-manual-account');
                        }}
                    />
                </YStack>
            </YStack>
        </KeyboardCompatibleBottomSheet>
    );
};

export default FailedConnectionSheet;
